import React, {createContext, useContext} from 'react'

import {OrderIntakeSite} from '../types/OrderIntakeSite.types'

interface JobSiteContextType {
  jobSite: OrderIntakeSite | null
}

const JobSiteContext = createContext<JobSiteContextType | undefined>(undefined)

interface JobSiteProviderProps {
  children: React.ReactNode
  jobSite: OrderIntakeSite | null
}

export const JobSiteProvider: React.FC<JobSiteProviderProps> = ({children, jobSite}) => {
  return <JobSiteContext.Provider value={{jobSite}}>{children}</JobSiteContext.Provider>
}

export const useJobSite = (): JobSiteContextType => {
  const context = useContext(JobSiteContext)
  if (context === undefined) {
    throw new Error('useJobSite must be used within a JobSiteProvider')
  }
  return context
}
